import React from 'react';
import './App.css';
import {initApolloClient} from "utils/apollo";
import CartProvider from "contexts/cart/cart.provider";
import StockItemProvider from "contexts/stock/stock.provider";
import CartPopUp from "components/Cart/CartPopUp";
import {ApolloProvider} from '@apollo/client';

function App() {
    const client: any = initApolloClient();
    return (
        <ApolloProvider client={client}>
            <StockItemProvider>
                <CartProvider>
                    <CartPopUp/>
                </CartProvider>
            </StockItemProvider>
        </ApolloProvider>
    );
}

export default App;
